var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 432.803,
    y2: 512.706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63950"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.496,
    x2: 277.471,
    y1: 491.949,
    y2: 344.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63950",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0467,
    stopColor: "#e4354b",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    stopColor: "#d31822",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7991,
    stopColor: "#c90709",
    stopOpacity: 0.799
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fce9cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbd95"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.364,
    x2: 137.417,
    xlinkHref: "#lg1",
    y1: 234.042,
    y2: 263.096
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.101,
    x2: 416.155,
    xlinkHref: "#lg1",
    y1: 234.042,
    y2: 263.096
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.343,
    x2: 309.565,
    xlinkHref: "#lg1",
    y1: 134.548,
    y2: 329.154
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.041,
    x2: 210.533,
    xlinkHref: "#lg2",
    y1: 213.201,
    y2: 239.693
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0471,
    stopColor: "#6e566e",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.404,
    x2: 220.52,
    xlinkHref: "#lg3",
    y1: 228.694,
    y2: 176.402
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.653,
    x2: 337.145,
    xlinkHref: "#lg2",
    y1: 213.201,
    y2: 239.693
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.017,
    x2: 347.133,
    xlinkHref: "#lg3",
    y1: 228.694,
    y2: 176.402
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.876,
    x2: 328.351,
    xlinkHref: "#lg2",
    y1: 122.605,
    y2: 216.65
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.162,
    x2: 254.747,
    y1: 78.784,
    y2: 188.126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa68e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9766e"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.202,
    x2: 344.81,
    xlinkHref: "#lg4",
    y1: 312.923,
    y2: 301.875
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.489,
    x2: 128.016,
    xlinkHref: "#lg5",
    y1: 350.682,
    y2: 371.502
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.801,
    x2: 107.329,
    xlinkHref: "#lg5",
    y1: 244.874,
    y2: 259.321
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-1 0 0 1 673.612 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 303.1,
    x2: 291.628,
    xlinkHref: "#lg5",
    y1: 350.682,
    y2: 371.502
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-1 0 0 1 673.612 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 282.413,
    x2: 270.94,
    xlinkHref: "#lg5",
    y1: 244.874,
    y2: 259.321
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 239.924,
    y2: 453.396
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.101,
    x2: 270.236,
    y1: 294.968,
    y2: 363.386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80d1c1"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1739,
    stopColor: "#117d9e",
    stopOpacity: 0.174
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#2389a0",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6928,
    stopColor: "#409ca3",
    stopOpacity: 0.693
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9986,
    stopColor: "#69b7a8",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b7a8"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 279.971,
    y2: 251.931
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 244.64,
    y2: 263.181
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 402.62,
    y2: 435.694
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 322.71,
    y2: 245.159
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 352.641,
    y2: 297.014
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 384.939,
    y2: 352.97
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m486.754 463.53c12.805 14.415 3.674 37.25-15.537 38.897-55.03 4.716-127.891 7.573-207.827 7.573-88.483 0-168.293-3.502-224.84-9.136-18.978-1.891-28.082-24.562-15.317-38.732.096-.107.192-.213.288-.32 56.824-63.133 139.197-102.821 230.831-102.821 90.65 0 172.172 38.793 228.952 100.717 1.16 1.265 2.31 2.538 3.45 3.822z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.754 463.53c-1.14-1.283-2.29-2.557-3.45-3.821-56.779-61.925-138.301-100.717-228.952-100.717-39.844 0-77.936 7.507-112.939 21.179 1.545 6.692 4.441 13.377 6.69 20.051 1.842 5.468 4.366 10.195 9.002 13.677l96.084 96.084c3.389.01 6.786.017 10.201.017 79.935 0 152.797-2.857 207.827-7.573 19.211-1.647 28.341-24.482 15.537-38.897z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.631 280.922c-16.863 0-30.534-13.67-30.534-30.534v-18.158c0-16.863 13.67-30.534 30.534-30.534 16.863 0 30.534 13.67 30.534 30.534v18.159c0 16.863-13.671 30.533-30.534 30.533z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.369 280.922c-16.863 0-30.534-13.67-30.534-30.534v-18.158c0-16.863 13.67-30.534 30.534-30.534 16.863 0 30.534 13.67 30.534 30.534v18.159c-.001 16.863-13.671 30.533-30.534 30.533z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 428.583c76.292 0 139.053-60.317 141.809-136.559 1.182-32.689 1.182-65.401 0-98.089-2.757-76.242-65.517-136.56-141.809-136.56-76.291 0-139.052 60.317-141.808 136.559-1.182 32.689-1.182 65.401 0 98.089 2.756 76.242 65.516 136.56 141.808 136.56z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m212.148 220.855c0 11.297-9.158 20.455-20.455 20.455s-20.454-9.158-20.454-20.455 9.158-20.455 20.454-20.455c11.297 0 20.455 9.158 20.455 20.455z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.844 202.557c1.38 2.753 2.157 5.861 2.157 9.15 0 11.297-9.158 20.455-20.454 20.455-3.289 0-6.397-.778-9.15-2.157 3.358 6.703 10.29 11.305 18.297 11.305 11.297 0 20.455-9.158 20.455-20.455-.001-8.008-4.603-14.94-11.305-18.298z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m338.761 220.855c0 11.297-9.158 20.455-20.455 20.455s-20.454-9.158-20.454-20.455 9.158-20.455 20.454-20.455c11.297 0 20.455 9.158 20.455 20.455z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.456 202.557c1.38 2.753 2.157 5.861 2.157 9.15 0 11.297-9.158 20.455-20.454 20.455-3.289 0-6.397-.778-9.15-2.157 3.358 6.703 10.29 11.305 18.297 11.305 11.297 0 20.455-9.158 20.455-20.455 0-8.008-4.602-14.94-11.305-18.298z",
    fill: "url(#SVGID_9_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m113.591 241.396 2.627-39.194c1.406-20.975 13.447-40.008 31.509-50.253 8.956-5.08 18.954-7.747 29.001-7.747h76.668c27.857 0 54.309-10.967 73.254-30.201l18.466 29.523c4.423 7.071 10.63 12.967 17.989 17.065 15.074 8.393 25.097 24.212 26.174 41.621l1.728 27.945c.323 5.23 4.68 9.488 9.728 9.488 4.204 0 7.657-2.984 8.368-7.218l12.524-74.636c3.59-21.393 4.48-42.895 2.734-64.029-2.606-31.537-33.582-54.715-64.845-49.244-40.035-36.187-94.832-51.433-147.556-41.586l-45.838 8.561c-41.556 7.761-73.429 43.221-74.706 84.806l-1.362 44.339c-.616 20.064.36 40.409 2.968 60.848l5.302 41.558c.473 3.707 3.413 6.369 7.046 6.369 4.244.001 7.924-3.595 8.221-8.015z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.516 44.515c-40.035-36.186-94.832-51.432-147.556-41.585l-45.838 8.561c-41.556 7.761-73.429 43.221-74.706 84.806l-1.362 44.339c-.616 20.064.36 40.409 2.968 60.848l5.302 41.558c.473 3.707 3.413 6.369 7.046 6.369 4.243 0 7.924-3.596 8.22-8.015l2.627-39.194c1.406-20.975 13.447-40.008 31.509-50.253 8.956-5.08 18.954-7.747 29.002-7.747h76.668c27.857 0 54.309-10.967 73.254-30.201.001 0-11.759-48.699 32.866-69.486z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m396.808 292.024c.526-14.551.804-29.107.862-43.663-10.903 9.739-24.965 17.76-42.393 19.263 0 0 14.856 52.283 9.343 109.236 19.12-23.191 31.023-52.588 32.188-84.836z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m151.148 381.782c-.022 0-.042 0-.063 0-11.306-.083-27.39-6.11-39.811-34.351-1.89-4.296.061-9.311 4.358-11.2 4.298-1.888 9.311.062 11.2 4.358 4.835 10.993 12.989 24.114 24.378 24.198 4.693.034 8.47 3.867 8.435 8.56-.035 4.671-3.833 8.435-8.497 8.435z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.56 272.92c-.012 0-.022 0-.034 0-23.805-.093-44.906-9.901-61.022-28.367-11.969-13.714-16.985-27.44-17.193-28.018-1.588-4.416.705-9.284 5.122-10.872 4.407-1.586 9.267.697 10.864 5.099.042.116 4.355 11.714 14.385 23.039 12.935 14.606 29.055 22.049 47.91 22.122 4.693.018 8.484 3.838 8.465 8.531-.018 4.683-3.82 8.466-8.497 8.466z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.852 381.782h.064c11.306-.083 27.39-6.11 39.811-34.351 1.89-4.296-.061-9.311-4.358-11.2-4.298-1.888-9.311.062-11.2 4.358-4.835 10.993-12.989 24.114-24.378 24.198-4.693.034-8.47 3.867-8.435 8.56.034 4.671 3.832 8.435 8.496 8.435z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.44 272.92h.034c23.805-.093 44.906-9.901 61.022-28.367 11.969-13.714 16.985-27.44 17.193-28.018 1.588-4.416-.705-9.284-5.122-10.872-4.407-1.586-9.267.697-10.864 5.099-.042.116-4.355 11.714-14.385 23.039-12.935 14.606-29.055 22.049-47.91 22.122-4.693.018-8.484 3.838-8.465 8.531.018 4.683 3.82 8.466 8.497 8.466z",
    fill: "url(#SVGID_16_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m263.749 332.009h-17.499c-14.023 0-24.949-12.164-23.449-26.106l9.149-85.048h46.098l9.149 85.048c1.501 13.942-9.424 26.106-23.448 26.106z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362.898 271.881c-3.245-9.631-11.697-16.974-22.278-19.238-56.862-12.166-114.38-12.166-171.241 0-10.581 2.264-19.033 9.607-22.278 19.238-14.365 42.633-14.363 85.712 0 128.34 3.245 9.631 11.697 16.974 22.278 19.238 56.861 12.166 114.378 12.166 171.241 0 10.581-2.264 19.033-9.607 22.278-19.237 14.363-42.63 14.365-85.708 0-128.341z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.898 271.881c-3.245-9.631-11.697-16.974-22.278-19.238-56.862-12.166-114.38-12.166-171.241 0-10.581 2.264-19.033 9.607-22.278 19.238-14.365 42.633-14.363 85.712 0 128.34 3.245 9.631 11.697 16.974 22.278 19.238 56.861 12.166 114.378 12.166 171.241 0 10.581-2.264 19.033-9.607 22.278-19.237 14.363-42.63 14.365-85.708 0-128.341z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.053 273.051c68.368-14.628 137.526-14.628 205.895 0 1.732.371 3.417.856 5.044 1.445 1.439.521 2.85-.848 2.362-2.299-.004-.013-.009-.026-.013-.039-3.319-9.849-11.962-17.358-22.782-19.673-58.149-12.441-116.969-12.441-175.117 0-10.82 2.315-19.463 9.824-22.782 19.673-.004.013-.009.026-.013.039-.488 1.451.923 2.82 2.362 2.299 1.627-.589 3.311-1.074 5.044-1.445z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.958 382.432c1.44 5.936 3.149 11.867 5.144 17.789 3.245 9.631 11.697 16.974 22.278 19.238 56.861 12.166 114.378 12.166 171.241 0 10.581-2.264 19.033-9.607 22.278-19.237 1.995-5.922 3.704-11.852 5.144-17.789h-226.085z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.62 419.458c10.581-2.264 19.033-9.607 22.278-19.237 11.237-33.35 13.682-66.974 7.337-100.445-76.549-15.826-153.922-15.826-230.471 0-6.345 33.471-3.899 67.096 7.337 100.445 3.245 9.631 11.697 16.974 22.278 19.238 56.862 12.165 114.379 12.165 171.241-.001z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.62 419.458c10.581-2.264 19.033-9.607 22.278-19.237 6.712-19.921 10.285-39.939 10.723-59.965-78.782-16.774-158.463-16.773-237.243 0 .439 20.026 4.012 40.044 10.724 59.965 3.245 9.631 11.697 16.974 22.278 19.238 56.861 12.165 114.378 12.165 171.24-.001z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.62 419.458c10.581-2.264 19.033-9.607 22.278-19.237 2.04-6.055 3.786-12.118 5.246-18.189-75.17-15.255-151.119-15.255-226.288 0 1.46 6.07 3.206 12.134 5.246 18.189 3.245 9.631 11.697 16.974 22.278 19.238 56.861 12.165 114.378 12.165 171.24-.001z",
    fill: "url(#SVGID_24_)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.3be90ae4e903c11457e8f2fcef8fdca8.svg";
export { ForwardRef as ReactComponent };